var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container-graph-sankey"}},[_c('div',{ref:"sankeyContainer",staticClass:"padre",attrs:{"id":"svg-sankey"}}),_c('div',{ref:"tooltip",staticClass:"tooltip",staticStyle:{"opacity":"0"},attrs:{"id":"tooltip"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }